export default (): boolean => process.env.DEPLOYABLE_ENV === 'development';
